import { ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { LayoutResolver } from 'app/views/presentations/layouts/layoutResolver';
import { LayoutResolverComponent } from 'app/views/presentations/layouts/layoutResolver.component';
import { FourSectionsLayoutModule } from 'app/views/presentations/layouts/layouts/fourSectionsLayout/fourSectionsLayout.module';
import { FourSectionsLayoutMirrorModule } from 'app/views/presentations/layouts/layouts/fourSectionsLayoutMirror/fourSectionsLayoutMirror.module';
import { FullscreenLayoutModule } from 'app/views/presentations/layouts/layouts/fullscreenLayout/fullscreenLayout.module';
import { ThreeSectionsLayout1Module } from 'app/views/presentations/layouts/layouts/threeSectionsLayout1/threeSectionsLayout1.module';
import { ThreeSectionsLayout2Module } from 'app/views/presentations/layouts/layouts/threeSectionsLayout2/threeSectionsLayout2.module';
import { ThreeSectionsLayout3Module } from 'app/views/presentations/layouts/layouts/threeSectionsLayout3/threeSectionsLayout3.module';
import { ThreeSectionsLayout4Module } from 'app/views/presentations/layouts/layouts/threeSectionsLayout4/threeSectionsLayout4.module';
import { TwoSectionsHorizontalLayoutModule } from 'app/views/presentations/layouts/layouts/twoSectionsHorizontalLayout/twoSectionsHorizontalLayout.module';
import { TwoSectionsHorizontalLayoutMirrorModule } from 'app/views/presentations/layouts/layouts/twoSectionsHorizontalLayoutMirror/twoSectionsHorizontalLayoutMirror.module';
import { TwoSectionsVerticalLayoutModule } from 'app/views/presentations/layouts/layouts/twoSectionsVerticalLayout/twoSectionsVerticalLayout.module';
import { TwoSectionsVerticalLayoutMirrorModule } from 'app/views/presentations/layouts/layouts/twoSectionsVerticalLayoutMirror/twoSectionsVerticalLayoutMirror.module';

import { WidgetModule } from './../widgets/widget.module';
import { LayoutSelectorComponent } from './layoutSelector.component';

@NgModule({
    imports: [
        BrowserModule,
        FourSectionsLayoutModule,
        FourSectionsLayoutMirrorModule,
        FullscreenLayoutModule,
        ThreeSectionsLayout1Module,
        ThreeSectionsLayout2Module,
        ThreeSectionsLayout3Module,
        ThreeSectionsLayout4Module,
        TwoSectionsHorizontalLayoutModule,
        TwoSectionsHorizontalLayoutMirrorModule,
        TwoSectionsVerticalLayoutModule,
        TwoSectionsVerticalLayoutMirrorModule,
        WidgetModule
    ],
    declarations: [
        LayoutResolverComponent,
        LayoutSelectorComponent
    ],
    exports: [
        LayoutResolverComponent,
        LayoutSelectorComponent
    ]
})
export class LayoutModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: LayoutModule,
            providers: [
                LayoutResolver
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layout.module.ts